












import { Component, Vue } from 'vue-property-decorator';
import HeaderBar from './components/HeaderBar.vue';
import FooterBar from './components/FooterBar.vue';

@Component({
    components: {
        HeaderBar,
        FooterBar,
    },
})
export default class Default extends Vue {
}
